export const FilterLabels = {
    'MyItems':
        {
            label: 'Owned'
        },
    'AllItems':
        {
            label: 'Total'
        },
    'AllSellOffers':
        {
            label: 'Best Buy Offer',
        },
    'AllBuyOffers':
        {
            label: 'Best Sell Offer',
        },
    'Alphabet':
        {
            label: 'Name',
        },

    getAllFilterLabels: function () {
        return [
            'MyItems',
            'AllItems',
            'AllSellOffers',
            'AllBuyOffers',
            'Alphabet'
        ];
    },
    getViewFilterLabels: function () {
        return [
            'MyItems',
            'AllItems',
            'AllSellOffers',
            'AllBuyOffers'
        ];
    }
}